import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { EmployeeTimesheet } from "../../models";
import { remove } from "../../api/generic-api";
import { RQ } from "../../globals/enums";
import { deleteEntity } from "../../utils";

export const useDeleteEmployeeTimesheet = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("employee-timesheets", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Employee Timesheet Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.EMPLOYEE_TIMESHEETS,
        (employeeTimesheets: EmployeeTimesheet[] | undefined) => {
          return !employeeTimesheets
            ? []
            : deleteEntity<EmployeeTimesheet>(employeeTimesheets, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Employee Timesheet Deleting Error", {
        variant: "error",
      });
    },
  });
};
